import {
  UPDATE_AVAILABLE_AGENTS,
  UPDATE_LIST_AGENTS_QUEUE,
  RESET_AGENTS,
  CLEAR_AGENT_HISTORY,
  SET_HISTORY_FOR_AGENT,
  SET_MESSAGES_FROM_HISTORY,
} from '../../mutation-types';

const mutations = {
  [UPDATE_AVAILABLE_AGENTS](state, availableAgents) {
    state.availableAgents = availableAgents;
  },

  [UPDATE_LIST_AGENTS_QUEUE](state, agents) {
    state.listAgentsQueue = agents;
  },

  [RESET_AGENTS](state) {
    state.availableAgents = [];
  },

  [CLEAR_AGENT_HISTORY](state) {
    state.history = {};
    state.paramsHistory = {};
  },

  [SET_HISTORY_FOR_AGENT](state, history) {
    Object.entries(history).forEach(([period, attendances]) => {
      const hasPeriodInHistory = state.history[period];

      if (hasPeriodInHistory)
        return (state.history[period] = [
          ...state.history[period],
          ...attendances,
        ]);

      state.history[period] = attendances;
    });
  },

  [SET_MESSAGES_FROM_HISTORY](state, { protocol, groupProtocol, messages }) {
    if (state.history[groupProtocol]) {
      const indexToMessages = state.history[groupProtocol].findIndex(
        (history) => history.protocol == protocol,
      );
      const history = state.history[groupProtocol][indexToMessages];
      history.messages = messages;
      state.history[groupProtocol].splice(indexToMessages, 1, history);
      // Object.assign(, { 'messages': messages })
    }
  },
};

export default mutations;
